const app = {
  appVersion: () => ({
    url: `/app-version`,
    method: 'get',
  }),
};

export default app;
